import { FormViewField } from 'components/FormView';

export default {
    formName: 'RecallParkedReceiptFilterRow',
    validate: null,
    rowModelType: 'serverSide',
    parameters: [
        {
            id: 0,
            type: 'EX_LOOKUP_FIELD',
            visible: true,
            props: {
                label: 'Warehouse',
                size: 'small',
                name: 'Warehouse',
                lookupName: 'WarehouseEntity',
                disabled: false,
                required: true
            }
        },
        {
            id: 1,
            type: 'EX_LOOKUP_FIELD',
            props: {
                label: 'Username',
                name: 'Username',
                lookupName: 'Username',
                placeholder: '',
                size: 'medium',
                suppressDescription: true
            }
        },
        {
            id: 2,
            type: 'EX_LOOKUP_FIELD',
            props: {
                label: 'Supplier',
                name: 'SupplierId',
                lookupName: 'Supplier',
                placeholder: '',
                size: 'medium'
            }
        }
    ] as FormViewField[]
};
